<template>
  <div style="position: relative;">
    <div class="common-box" style="margin-top: 10px;border-top: 1px solid #c8c8c8;">
      <el-row class="row-one">
        <span class="row-one-title">恒宝宝资产信息</span>
        <Reback v-show="this.$route.name !== 'myAssets'" class="row-one-fr" @click.native="returnClick"></Reback>
      </el-row>
      <ul class="message_record clearfix">
        <li>
          可用金额 (元)：
          <span>{{availbal}}</span>
        </li>
        <li>
          在途金额 (元)：
          <span>{{unavailbal}}</span>
        </li>
        <li>
          近一月平均收益率：
          <span v-if="monthAverage > 0" class="rColor">{{monthAverage+ "%"}}</span>
          <span v-else-if="monthAverage < 0" class="gColor">{{monthAverage+ "%"}}</span>
          <span v-else>{{monthAverage =='--'?'--':monthAverage+ "%"}}</span>
        </li>
        <!-- <li>
              点财通会员返现已转入：
              <span class="rColor">1963.60</span>
            </li> -->
      </ul>
      <!-- 图表 -->
      <div class="margin-t10">
        <div id="hbbsyl" v-loading="echartsLoading" element-loading-text="加载中..." style="width:1148px;height:320px"> </div>
      </div>
      <!-- 月收益 -->
      <div class="hbbYear">
        <!-- 月表格 -->
        <el-table class="table-one" :data="hbbMonthRatetableData" v-loading="loadingOne" element-loading-text="加载中..." border style="width: 100%;margin-top:20px;">
          <el-table-column prop="navdate1" label="日期">
          </el-table-column>
          <el-table-column prop="growthrate1" label="七日年化收益率">
          </el-table-column>
          <el-table-column prop="navdate2" label="日期">
          </el-table-column>
          <el-table-column prop="growthrate2" label="七日年化收益率">
          </el-table-column>
          <el-table-column prop="navdate3" label="日期">
          </el-table-column>
          <el-table-column prop="growthrate3" label="七日年化收益率">
          </el-table-column>
          <el-table-column prop="navdate4" label="日期">
          </el-table-column>
          <el-table-column prop="growthrate4" label="七日年化收益率">
          </el-table-column>
        </el-table>
      </div>
      <!-- 累计收益 -->
      <div class="hbbCumulative" style="margin-top:30px;">
        <ul class="message_record clearfix">
          <li>
            估算累计收益 (元)：
            <span v-if="estimatedTotalIncome > 0" class="rColor">{{estimatedTotalIncome}}</span>
            <span v-else-if="estimatedTotalIncome < 0" class="gColor">{{estimatedTotalIncome}}</span>
            <span v-else>{{estimatedTotalIncome}}</span>
          </li>
          <li>
            已结转收益 (元)：
            <span v-if="carriedForwardIncome > 0" class="rColor">{{carriedForwardIncome}}</span>
            <span v-else-if="carriedForwardIncome < 0" class="gColor">{{carriedForwardIncome}}</span>
            <span v-else>{{carriedForwardIncome}}</span>
          </li>
          <li>
            估算未付收益 (元)：
            <span v-if="estimatedUnpaidIncome > 0" class="rColor">{{estimatedUnpaidIncome}}</span>
            <span v-else-if="estimatedUnpaidIncome < 0" class="gColor">{{estimatedUnpaidIncome}}</span>
            <span v-else>{{estimatedUnpaidIncome}}</span>
            <!-- <span :class="estimatedUnpaidIncome >= 0? 'rColor':'gColor'">{{estimatedUnpaidIncome}}</span> -->
          </li>
        </ul>
        <!-- 累计收益表格 -->
        <el-table v-loading="loadingTwo" element-loading-text="加载中..." class="table-one" style="width: 100%;" :data="hbbCumulativeTableData" border>
          <el-table-column prop="transactiondate1" label="日期">
          </el-table-column>
          <el-table-column prop="amount1" label="每日收益 ( 元 )">
          </el-table-column>
          <el-table-column prop="transactiondate2" label="日期">
          </el-table-column>
          <el-table-column prop="amount2" label="每日收益 ( 元 )">
          </el-table-column>
          <el-table-column prop="transactiondate3" label="日期">
          </el-table-column>
          <el-table-column prop="amount3" label="每日收益 ( 元 )">
          </el-table-column>
          <el-table-column prop="transactiondate4" label="日期">
          </el-table-column>
          <el-table-column prop="amount4" label="每日收益 ( 元 )">
          </el-table-column>
        </el-table>
        <!-- 页码 -->
        <el-pagination class="pagination-single el-pagination" @size-change="handleSizeChangeOne" @current-change="handleCurrentChangeOne" :current-page.sync="incomePage.Page" :page-size="incomePage.PageNum" layout="prev, pager, next" :total="total" hide-on-single-page>
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
export default {
  name: "hbb",
  data () {
    return {
      availbal: '--',
      unavailbal: '--',
      monthAverage: '--',
      allRate: 0,
      hbbMonthRatetableData: [
        {
          date: '2016-05-02',
          name: '2.58%',

        }, {
          date: '2016-05-04',
          name: '2.58%',
        }, {
          date: '2016-05-01',
          name: '2.58%',
        }, {
          date: '2016-05-03',
          name: '2.58%',
        }
      ],
      hbbCumulativeTableData: [],
      // 恒宝宝图表
      xdata: [],
      hbbserierData: [
        {
          name: '七日年化收益率',
          data: [0],
          type: 'line',
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: '#f8930a'
            }, {
              offset: 1,
              color: '#fff'
            }])
          },
          symbol: 'none',
          itemStyle: {
            color: '#f8930a',
          }
        }
      ],
      incomePage: {
        Page: 1,
        PageNum: 40
      },
      total: 0,

      echartsLoading: true,
      loadingOne: true,
      loadingTwo: true,


      // 累计收益汇总
      estimatedTotalIncome: '0.00',
      carriedForwardIncome: '0.00',
      estimatedUnpaidIncome: '0.00',
      // 路由前一个地址
      lastroute: '',
    }
  },
  mounted () {
    this.getHbbCumulationProfit()
    this.getHbbCumulationProfitTable()
    this.getSevenAnnualization()
    this.getSy()
    this.$commonEcharts.echartsOne('hbbsyl', this.xdata, false, this.hbbserierData, 2.35, '%', { 'yScale1': true })
  },
  methods: {
    returnClick () {
      if (this.$route.params.value == "recharge") {
        this.$router.push({
          name: 'recharge'
        })
      } else if (this.$route.params.value == "fixedInvestment") {
        this.$router.push({
          name: 'fixedInvestment'
        })
      } else if (this.$route.params.value == "takeCash") {
        this.$router.push({
          name: 'takeCash'
        })
      } else if (this.$route.params.value == "record") {
        this.$router.push({
          name: 'record'
        })
      }
    },
    handleSizeChangeOne (newSize) {
      this.incomePage.PageNum = newSize
      this.getHbbCumulationProfitTable()
    },
    handleCurrentChangeOne (newPage) {
      this.loadingTwo = true
      this.incomePage.Page = newPage
      this.getHbbCumulationProfitTable()
    },
    // 可用金额,在途金额
    getSy () {
      this.$http.post(this.$apiPath.getPrivatelyFloat, {
        sessionId: this.$commonJs.getCookie('sessionid'),
        fundcode: '162206',
        appnew: '1'
      }).then(res => {
        if (res.data.data) {
          // console.log(res);
          const total = res.data.data[0]
          this.availbal = parseFloat(total.availbal).toFixed(2)
          this.unavailbal = parseFloat(total.unavailbal).toFixed(2)

        }
      }).catch(err => { })
    },
    // 恒宝宝累计收益汇总
    getHbbCumulationProfit () {
      this.$http.post(this.$apiPath.showMyDetails, {
        sessionId: this.$commonJs.getCookie('sessionid'),
        custno: this.$commonJs.getCookie('u_custno1')
      }).then(res => {
        if (res.status !== 200) return
        if (res.data.code !== '200') return
        const result = res.data.data
        // console.log(result);
        if (result) {
          this.estimatedTotalIncome = this.$commonJs.amountFormat((new Number(result[0].total).toFixed(2)))
          this.carriedForwardIncome = this.$commonJs.amountFormat((new Number(result[0].paid).toFixed(2)))
          this.estimatedUnpaidIncome = this.$commonJs.amountFormat((new Number(result[0].unpaid).toFixed(2)))
        }

      }).catch(() => { })
    },
    // 累计收益汇总表
    getHbbCumulationProfitTable () {
      this.$http.post(this.$apiPath.showMyDetailsTable, {
        sessionId: this.$commonJs.getCookie('sessionid'),
        custno: this.$commonJs.getCookie('u_custno1'),
        page: this.incomePage.Page,
        pageSize: this.incomePage.PageNum
      }).then(res => {
        if (res.status !== 200) return
        if (res.data.code !== '200') return
        const total = res.data.data
        if (total) {
          this.loadingTwo = false
          const arr = []
          for (var i = 0; i < total.fristRecord.length; i += 4) {
            arr.push(total.fristRecord.slice(i, i + 4));
          }
          // console.log(arr);
          arr.forEach((item, i) => {
            if (item[0]) {
              item.transactiondate1 = this.$commonJs.getDateStrTh(item[0].transactiondate)
              item.amount1 = item[0].amount
            }
            if (item[1]) {
              item.transactiondate2 = this.$commonJs.getDateStrTh(item[1].transactiondate)
              item.amount2 = item[1].amount
            }
            if (item[2]) {
              item.transactiondate3 = this.$commonJs.getDateStrTh(item[2].transactiondate)
              item.amount3 = item[2].amount
            }
            if (item[3]) {
              item.transactiondate4 = this.$commonJs.getDateStrTh(item[3].transactiondate)
              item.amount4 = item[3].amount
            }

          })
          this.hbbCumulativeTableData = arr
          this.total = total.totalNum
          // this.incomePage.PageNum = total.totalNum
        }

      }).catch(() => { })
    },
    // 七日年化图表
    getSevenAnnualization () {
      this.$http.post(this.$apiPath.getOneMonth, {
        sessionId: this.$commonJs.getCookie('sessionid')
      }).then(res => {
        // console.log(res);
        if (res.status !== 200) return
        if (res.data.code !== '200') return
        const total = res.data.data
        if (total != null && total.benchRecord.length > 0) {
          // console.log(total);


          // 收益率
          total.benchRecord.forEach(rateItem => {
            this.allRate += parseFloat(rateItem.growthrate)
          })
          this.monthAverage = parseFloat(this.allRate / total.benchRecord.length * 100).toFixed(3)
          //折线图数据
          this.echartsLoading = false
          let arrOne = []
          arrOne = total.benchRecord.slice(0, 7).reverse()
          this.hbbserierData.data = []
          arrOne.forEach(val => {
            if (val && val.navdate && val.growthrate) {
              this.xdata.push(this.$commonJs.getDateStrHg(val.navdate))
              this.hbbserierData.data.push(parseFloat(val.growthrate * 100).toFixed(2))
            }
          })
          const minNum = Math.min.apply(null, this.hbbserierData.data)  // 纵坐标最小值
          this.hbbserierData = [
            {
              name: '七日年化收益率',
              data: this.hbbserierData.data,
              type: 'line',
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: '#f8930a'
                }, {
                  offset: 1,
                  color: '#fff'
                }])
              },
              symbol: 'none',
              itemStyle: {
                color: '#f8930a',
              }
            }
          ]
          this.$commonEcharts.echartsOne('hbbsyl', this.xdata, false, this.hbbserierData, minNum, '%', { 'yScale1': true })
          // 表格数据
          this.loadingOne = false
          let arrTwo = []
          for (var i = 0; i < total.benchRecord.length; i += 4) {
            arrTwo.push(total.benchRecord.slice(i, i + 4));
          }

          arrTwo.forEach((item, i) => {
            if (item[0]) {
              item.navdate1 = this.$commonJs.getDateStrTh(item[0].navdate)
              item.growthrate1 = parseFloat(item[0].growthrate * 100).toFixed(2) + '%'
            }
            if (item[1]) {
              item.navdate2 = this.$commonJs.getDateStrTh(item[1].navdate)
              item.growthrate2 = parseFloat(item[1].growthrate * 100).toFixed(2) + '%'
            }
            if (item[2]) {
              item.navdate3 = this.$commonJs.getDateStrTh(item[2].navdate)
              item.growthrate3 = parseFloat(item[2].growthrate * 100).toFixed(2) + '%'
            }
            if (item[3]) {
              item.navdate4 = this.$commonJs.getDateStrTh(item[3].navdate)
              item.growthrate4 = parseFloat(item[3].growthrate * 100).toFixed(2) + '%'
            }
          })
          this.hbbMonthRatetableData = arrTwo
        } else {
          // console.log('无数据');
          this.hbbMonthRatetableData = []

        }


      }).catch(() => { })
    }


  }
}
</script>


<style lang="less" scoped>
// 数据
.message_record {
  li {
    float: left;
    margin: 24px 50px 24px 0;
    color: #333;
    span {
      font-weight: bold;
    }
  }
}
</style>